<tabs>
  <tab-single
    [tabId]="tabIdList.MNG__CLINICS"
    [link]="urlMngClinics"
    tabTitle="translate.mng.clinics"
  ></tab-single>

  <tab-single
    *ngIf="allowDrProfiles"
    [tabId]="tabIdList.MNG__DR_PROFILE"
    [link]="urlMngDrProfile"
    tabTitle="translate.mng.drProfile"
  >
  </tab-single>

  <tab-single
    [tabId]="tabIdList.MNG__USERS"
    [link]="urlMngUsers"
    tabTitle="translate.mng.users"
  >
  </tab-single>

  <tab-single
    [tabId]="tabIdList.MNG__PARAMS"
    [link]="urlMngParams"
    tabTitle="translate.mng.params"
  >
  </tab-single>
</tabs>

<modal-popup
  [flexible]="true"
  [hideHeader]="true"
  (onClose)="createUserPanelDisplay = false"
  [isOpen]="createUserPanelDisplay"
>
  <user-edit
    *ngIf="createUserPanelDisplay"
    [user]="selectedUser"
    (onCancel)="createUserPanelDisplay = false"
  ></user-edit>
</modal-popup>
